module.exports = __webpack_public_path__ + "static/media/5.d325a037.jpg";